module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "工号 / 姓名"
    },
    model: {
      value: (_vm.queryForm.gh),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "gh", $$v)
      },
      expression: "queryForm.gh"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "所属部门",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.bm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "bm", $$v)
      },
      expression: "queryForm.bm"
    }
  }, _vm._l((_vm.deptItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "所属教研室",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.ssjys),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "ssjys", $$v)
      },
      expression: "queryForm.ssjys"
    }
  }, _vm._l((_vm.teachGroupItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 新建")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.ydxx
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" 异动信息")]), _vm._v(" "), (_vm.syncDataVisible) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.syncTeaData
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 同步教职工信息")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.teacherTemplete
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 教师模板")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadJs
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 教师导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportJs
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 教师导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.queryForm.pageNum - 1) * _vm.queryForm.rowNum + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工号",
      "prop": "gh",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "xm",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属部门",
      "prop": "bmmc",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属教研室",
      "prop": "ssjysmc",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.modRec(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document"
        }), _vm._v(" 异动处理\n                ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-sizes": [10, 20, 30, 40, 50],
      "page-size": _vm.queryForm.rowNum,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "customElRow",
    attrs: {
      "title": _vm.CurdDialogTitle,
      "visible": _vm.CurdDialogVisible,
      "width": "1040px",
      "top": "100px"
    },
    on: {
      "update:visible": function($event) {
        _vm.CurdDialogVisible = $event
      },
      "close": _vm.closeCurdDialog
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基础信息",
      "name": "baseInfo"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "扩展信息",
      "name": "expandInfo"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInfoVisible),
      expression: "baseInfoVisible"
    }]
  }, [_c('el-form', {
    ref: "baseInfoForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "110px",
      "label-position": "left",
      "rules": _vm.CurdRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "xm"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.xm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xm", $$v)
      },
      expression: "curdForm.xm"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "gh"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": _vm.modFlag
    },
    model: {
      value: (_vm.curdForm.gh),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gh", $$v)
      },
      expression: "curdForm.gh"
    }
  })], 1), _vm._v(" "), (!_vm.modFlag) ? _c('el-form-item', {
    attrs: {
      "label": "自动获取工号"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": _vm.loadGh
    }
  }, [_vm._v("外聘")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名拼音",
      "prop": "xmpy"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.xmpy),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xmpy", $$v)
      },
      expression: "curdForm.xmpy"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "曾用名",
      "prop": "cym"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.cym),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "cym", $$v)
      },
      expression: "curdForm.cym"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "参加工作年月",
      "prop": "cjgzny"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "align": "right",
      "type": "month",
      "value-format": "yyyy-MM",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.curdForm.cjgzny),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "cjgzny", $$v)
      },
      expression: "curdForm.cjgzny"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "xbm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.xbm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xbm", $$v)
      },
      expression: "curdForm.xbm"
    }
  }, _vm._l((_vm.xbmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证件类型",
      "prop": "sfzjlxm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.sfzjlxm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "sfzjlxm", $$v)
      },
      expression: "curdForm.sfzjlxm"
    }
  }, _vm._l((_vm.sfzjlxmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证件号",
      "prop": "sfzjh"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "onkeyup": "this.value=this.value.replace(/[^\\X0-9]/g, '')"
    },
    model: {
      value: (_vm.curdForm.sfzjh),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "sfzjh", $$v)
      },
      expression: "curdForm.sfzjh"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属部门",
      "prop": "bm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.deptCodes),
      callback: function($$v) {
        _vm.deptCodes = $$v
      },
      expression: "deptCodes"
    }
  }, _vm._l((_vm.deptItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属教研室",
      "prop": "ssjys"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.teachGroups),
      callback: function($$v) {
        _vm.teachGroups = $$v
      },
      expression: "teachGroups"
    }
  }, _vm._l((_vm.teachGroupItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位等级",
      "prop": "gwdj"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.gwdj),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gwdj", $$v)
      },
      expression: "curdForm.gwdj"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位名称",
      "prop": "gwmc"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.gwmc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gwmc", $$v)
      },
      expression: "curdForm.gwmc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否行政兼职",
      "prop": "sfxzjz"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.sfxzjz),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "sfxzjz", $$v)
      },
      expression: "curdForm.sfxzjz"
    }
  }, _vm._l((_vm.sfztItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否外聘教师",
      "prop": "sfwpjs"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.sfwpjs),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "sfwpjs", $$v)
      },
      expression: "curdForm.sfwpjs"
    }
  }, _vm._l((_vm.sfztItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职称",
      "prop": "zcm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.zcm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zcm", $$v)
      },
      expression: "curdForm.zcm"
    }
  }, _vm._l((_vm.jszcItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "accept": ".png,.jpeg,.jpg",
      "action": "",
      "http-request": _vm.uploadPhoto,
      "show-file-list": false,
      "file-list": _vm.fileList,
      "disabled": _vm.photoFlag
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "photoImg",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('div', {
    staticClass: "photoArea"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.photoFlag),
      expression: "photoFlag"
    }],
    staticClass: "el-upload__tip",
    staticStyle: {
      "text-align": "center",
      "color": "#0000FF"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("工号生成后可上传照片")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.photoFlag),
      expression: "!photoFlag"
    }],
    staticClass: "el-upload__tip",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("点击照片区域上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("格式 png,jpeg,jpg")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("建议规格 240px*320px")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "10px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": _vm.imageUrl == ''
    },
    on: {
      "click": _vm.delPhoto
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v(" 删除照片\n                                ")])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandInfoVisible),
      expression: "expandInfoVisible"
    }]
  }, [_c('el-form', {
    ref: "expandInfoForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "100px",
      "label-position": "left",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月",
      "prop": "csrq"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "align": "right",
      "type": "month",
      "value-format": "yyyy-MM",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.curdForm.csrq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "csrq", $$v)
      },
      expression: "curdForm.csrq"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄",
      "prop": "nl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.curdForm.nl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "nl", $$v)
      },
      expression: "curdForm.nl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "国籍",
      "prop": "gjdqm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.gjdqm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gjdqm", $$v)
      },
      expression: "curdForm.gjdqm"
    }
  }, _vm._l((_vm.gbdmItem), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "籍贯",
      "prop": "jg"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.jg),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "jg", $$v)
      },
      expression: "curdForm.jg"
    }
  }, _vm._l((_vm.csdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "港澳台侨外",
      "prop": "gatqwm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.gatqwm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "gatqwm", $$v)
      },
      expression: "curdForm.gatqwm"
    }
  }, _vm._l((_vm.gatqdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "民族",
      "prop": "mzm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.mzm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "mzm", $$v)
      },
      expression: "curdForm.mzm"
    }
  }, _vm._l((_vm.mzdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "政治面貌",
      "prop": "zzmmm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.zzmmm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zzmmm", $$v)
      },
      expression: "curdForm.zzmmm"
    }
  }, _vm._l((_vm.zzmmdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "婚姻状况",
      "prop": "hyztm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.hyztm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "hyztm", $$v)
      },
      expression: "curdForm.hyztm"
    }
  }, _vm._l((_vm.hyzkmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入何党派",
      "prop": "rhdp"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.rhdp),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "rhdp", $$v)
      },
      expression: "curdForm.rhdp"
    }
  }, _vm._l((_vm.dpdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年月",
      "prop": "ny"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "align": "right",
      "type": "month",
      "value-format": "yyyy-MM",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.curdForm.ny),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "ny", $$v)
      },
      expression: "curdForm.ny"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "健康状况",
      "prop": "jkzkm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.jkzkm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "jkzkm", $$v)
      },
      expression: "curdForm.jkzkm"
    }
  }, _vm._l((_vm.jkztmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "血型",
      "prop": "xxm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.xxm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xxm", $$v)
      },
      expression: "curdForm.xxm"
    }
  }, _vm._l((_vm.xxdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "户口类别",
      "prop": "hklbm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.hklbm),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "hklbm", $$v)
      },
      expression: "curdForm.hklbm"
    }
  }, _vm._l((_vm.hkxzmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前住址",
      "prop": "dqzz"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.dqzz),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "dqzz", $$v)
      },
      expression: "curdForm.dqzz"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "毕业学校",
      "prop": "byxx"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.byxx),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "byxx", $$v)
      },
      expression: "curdForm.byxx"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "毕业专业",
      "prop": "byzy"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.curdForm.byzy),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "byzy", $$v)
      },
      expression: "curdForm.byzy"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "毕业时间",
      "prop": "bysjny"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "align": "right",
      "type": "month",
      "value-format": "yyyy-MM",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.curdForm.bysjny),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "bysjny", $$v)
      },
      expression: "curdForm.bysjny"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学历",
      "prop": "xl"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.xl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xl", $$v)
      },
      expression: "curdForm.xl"
    }
  }, _vm._l((_vm.xldmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学位",
      "prop": "xw"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.xw),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "xw", $$v)
      },
      expression: "curdForm.xw"
    }
  }, _vm._l((_vm.xwdmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "双一流高校",
      "prop": "sfsylgx"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.sfsylgx),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "sfsylgx", $$v)
      },
      expression: "curdForm.sfsylgx"
    }
  }, _vm._l((_vm.sfztItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否师范专业",
      "prop": "sfsfzy"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.sfsfzy),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "sfsfzy", $$v)
      },
      expression: "curdForm.sfsfzy"
    }
  }, _vm._l((_vm.sfztItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "bz"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "870px"
    },
    model: {
      value: (_vm.curdForm.bz),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "bz", $$v)
      },
      expression: "curdForm.bz"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.CurdDialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "异动信息",
      "visible": _vm.dialogVisible,
      "width": "1000px",
      "top": "100px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "工号"
    },
    model: {
      value: (_vm.ydxxForm.gh),
      callback: function($$v) {
        _vm.$set(_vm.ydxxForm, "gh", $$v)
      },
      expression: "ydxxForm.gh"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "250px",
      "margin-left": "10px"
    },
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.ydxxForm.xm),
      callback: function($$v) {
        _vm.$set(_vm.ydxxForm, "xm", $$v)
      },
      expression: "ydxxForm.xm"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.ydxxHandleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.ydxxHandleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "materialTable",
    attrs: {
      "data": _vm.ydxxTableData,
      "element-loading-text": "信息加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": "500px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.ydxxForm.pageNum - 1) * _vm.ydxxForm.rowNum + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工号",
      "prop": "gh",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "xm",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原状态",
      "prop": "yzt",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动类型",
      "prop": "ydlx",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动日期",
      "prop": "ydrq",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动原因",
      "prop": "ydyy",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.ydxxForm.pageNum,
      "page-sizes": [10, 20, 30, 40, 50],
      "page-size": _vm.ydxxForm.rowNum,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.ydxxTotal
    },
    on: {
      "size-change": _vm.ydxxHandleSizeChange,
      "current-change": _vm.ydxxHandlePageChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.ydxxForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.ydxxForm, "pageNum", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "异动处理",
      "visible": _vm.ydclDialogVisible,
      "width": "600px",
      "top": "200px"
    },
    on: {
      "update:visible": function($event) {
        _vm.ydclDialogVisible = $event
      },
      "closed": _vm.closeYdcl
    }
  }, [_c('el-form', {
    ref: "ydclForm",
    attrs: {
      "model": _vm.ydclForm,
      "label-width": "120px",
      "label-position": "left",
      "rules": _vm.ydclRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "gh"
    }
  }, [_vm._v(_vm._s(_vm.ydclForm.gh))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "xm"
    }
  }, [_vm._v(_vm._s(_vm.ydclForm.xm))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "异动类型",
      "prop": "ydlxm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ydclForm.ydlxm),
      callback: function($$v) {
        _vm.$set(_vm.ydclForm, "ydlxm", $$v)
      },
      expression: "ydclForm.ydlxm"
    }
  }, _vm._l((_vm.jsdqztmItem), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "异动日期",
      "prop": "ydrq"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "right",
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ydclForm.ydrq),
      callback: function($$v) {
        _vm.$set(_vm.ydclForm, "ydrq", $$v)
      },
      expression: "ydclForm.ydrq"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "异动原因",
      "prop": "ydyy"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请填写异动说明",
      "maxlength": "1000",
      "rows": 5,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.ydclForm.ydyy),
      callback: function($$v) {
        _vm.$set(_vm.ydclForm, "ydyy", $$v)
      },
      expression: "ydclForm.ydyy"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveYdcl
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.ydclDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "upload",
    attrs: {
      "accept": ".xlsx, .xls",
      "file-list": _vm.fileList,
      "action": "",
      "http-request": _vm.handleUpload,
      "show-file-list": false,
      "multiple": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae58b20c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baseInfo/teacher.vue
// module id = 1888
// module chunks = 502